import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable } from "rxjs";
import { FilterType } from "../../types/shared/_filter.type";
import { SortType } from "../../types/shared/sort.type";

export class BaseDataSource<T> extends DataSource<T> {
    rows: any[] = [];
    collectionList: BehaviorSubject<Array<T>> = new BehaviorSubject<Array<T>>(
        []
    );
    count = 0;
    summary: any = {};
    loading = false;
    filter: FilterType = new FilterType();

    constructor(private requestService: any) {
        super();
    }

    connect(collectionViewer?: CollectionViewer): Observable<T[]> {
        return this.collectionList;
    }

    getList() {
        const self = this;

        if (!self.requestService) {
            return;
        }

        self.loading = true;

        // self.count += self.filter;
        self.requestService.getList(self.filter).subscribe((res) => {
            self.collectionList.next(res.list);
            self.count = res.count;
            self.rows = res.rows;
            self.loading = false;
        });
    }

    sortData(field: string, direction: string) {
        /*  this.filter.sort = [];

    if (direction !== '') {
      this.filter.sort.push(new SortType(field, direction));
    }

    this.getList(); */
    }

    create(data: T): Observable<boolean> {
        return this.requestService.create(data);
    }

    update(data: T): Observable<boolean> {
        return this.requestService.update(data);
    }

    delete(id: number): Observable<boolean> {
        return this.requestService.delete(id);
    }

    activationToggle(id: number): Observable<boolean> {
        return this.requestService.activationToggle(id);
    }

    disconnect(collectionViewer?: CollectionViewer): void {}
}
